"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroup = void 0;
const isGroup = (item) => {
    return item.type === 'group';
};
exports.isGroup = isGroup;
